import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./auth/auth.slice";
import dashboardReducer from "./dashboard/dashboard.slice";
import userReducer from "./user/user.slice";
import restaurantReducer from "./restaurant/restaurant.slice";
import bookingReducer from "./booking/booking.slice";
import revenueReducer from './revenue/revenue.slice';
import surveyReducer from "./survey/survey.slice";
import appVersionReducer from "./app-version/app-version.slice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  user: userReducer,
  restaurant: restaurantReducer,
  booking: bookingReducer,
  revenue: revenueReducer,
  survey: surveyReducer,
  appVersion: appVersionReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
